import * as actions from './eStoreHomePage/actions'
import * as mutations from './eStoreHomePage/mutations'
import * as getters from './eStoreHomePage/getters'

import { dataProps } from './eStoreHomePage/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreHomePage.js